module.exports = require("./libs/csv2json.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/csvtojson/index.js
// module id = 688
// module chunks = 0